module.exports = __webpack_public_path__ + "static/media/alert-triangle.0206ef11.svg";